export const FETCH_GET_ALL_COMMENTS = 'FETCH_GET_ALL_COMMENTS';
export const FETCH_CREATE_COMMENT = 'FETCH_CREATE_COMMENT';
export const FETCH_UPDATE_COMMENT = 'FETCH_UPDATE_COMMENT';
export const FETCH_DELETE_COMMENT = 'FETCH_DELETE_COMMENT';
